export default {
	methods: {
		// GET TOTAL DATA OF MULTIPLE CHART
		totalData(data) {
			let total = 0
			data.forEach((val, key) => {
				if (key > 0) {
					total += val.length - 1
				}
			})
			return total
		},
		barWidth(data) {
			let barWidth = 'auto'

			if (data == 1) {
				barWidth = '20%'
			} else if (data >= 2 && data <= 4) {
				barWidth = '40%'
			} else if (data >= 5 && data <= 7) {
				barWidth = '60%'
			} else if (data >= 8 && data <= 16) {
				barWidth = '80%'
			} else if (data >= 17) {
				barWidth = '70%'
			}

			return barWidth
		},
		barWidthMultiple(data) {
			let barWidth = 'auto'

			if (data <= 6) {
				barWidth = '12%'
			} else if (data >= 7 && data <= 27) {
				barWidth = '20%'
			} else barWidth = '19%'

			return barWidth
		},
		roast(options) {
			/* eslint-disable */
			let chartOptions = {}
			let xAxis = {}
			let yAxis = {}
			let series = []
			let seriesName = ''

            if ('title' in options) {
				chartOptions['title'] = {
					text: options.title
				}
			}
			
            if ('title' in options) {
				chartOptions['subtitle'] = {
					text: options.subtitle
				}
			}
			
            if ('xAxis' in options && Object.keys(options.xAxis).length > 0) {
				let x = options.xAxis
				if('title' in x) {
					xAxis['title'] = {
						text: x.title
					}
				}
				if('categories' in x) {
					xAxis['categories'] = x.categories
				}
				chartOptions['xAxis'] = xAxis
			}
			
            if ('yAxis' in options && Object.keys(options.yAxis).length > 0) {
				let y = options.yAxis
				if('title' in y) {
					yAxis['title'] = {
						text: y.title
					}
				}
				chartOptions['yAxis'] = yAxis
			}
			
			if ('name' in options) {
				seriesName = options.name
			}
            
            if ('data' in options) {
				if(Array.isArray(options.data)) {
					series.push({
						name: seriesName,
						data: options.data
					})
				}
				else if(typeof options.data === 'object' && options.data !== null){
					series.push({
						name: seriesName,
						data: options.data
					})
				}
				else {
					//csv
					series.push({
						name: seriesName
					})
					chartOptions['data'] = {
						csv: options.data
					}
				}

				chartOptions['series'] = series
			}

			if ('series' in options) {
				series = options.series
			}
			
			return chartOptions

			/* eslint-enable */
		},
		roastV2(options, data = null) {
			/* eslint-disable */
			let chartOptions = {}
			let xAxis = {}
			let yAxis = {}
			let series = []
			let seriesName = ''

            if ('title' in options) {
				chartOptions['title'] = {
					text: options.title
				}
			}
			
            if ('title' in options) {
				chartOptions['subtitle'] = {
					text: options.subtitle
				}
			}
			
            if ('xAxis' in options && Object.keys(options.xAxis).length > 0) {
				let x = options.xAxis
				if('title' in x) {
					xAxis['title'] = {
						text: x.title
					}
				}
				if('categories' in x) {
					xAxis['categories'] = x.categories
				}
				chartOptions['xAxis'] = xAxis
			}
			
            if ('yAxis' in options && Object.keys(options.yAxis).length > 0) {
				let y = options.yAxis
				if('title' in y) {
					yAxis['title'] = {
						text: y.title
					}
				}
				chartOptions['yAxis'] = yAxis
			}
			
			if ('name' in options) {
				seriesName = options.name
			}
            
            if (data !== null) {
				if(Array.isArray(data)) {
					series.push({
						name: seriesName,
						data: data
					})
				}
				else if(typeof data === 'object' && data !== null){
					series.push({
						name: seriesName,
						data: data
					})
				}
				else {
					//csv
					series.push({
						name: seriesName
					})
					chartOptions['data'] = {
						csv: data
					}
				}

				chartOptions['series'] = series
			}

			if ('series' in options) {
				series = options.series
			}
			
			return chartOptions

			/* eslint-enable */
		}
	}
}
